import { keyframes } from "@emotion/css";
import styled from "@emotion/styled";
const moveUp = keyframes `
  from {transform: translateY(50px);}
  to {transform: unset;}
`;
const ReplyMessage = {
    ReplyWrapper: styled.div `
    border-radius: 0.7em 0.7em 0 0;
    color: ${({ theme }) => theme.color.textMuted};
    ${(props) => props.hasCloseBtn &&
        `
      background-color: ${props.theme.color.inputBackground};
      margin: 1em 2em -2em;
      padding: 0.5rem 1rem calc(0.5rem + 1em);
      animation: ${moveUp} 1s 1;
    `}
  `,
    ReplyInnerWrapper: styled.div `
    background-color: ${({ theme }) => theme.color.backgroundReply};
    border-radius: 0.5em;
    padding: 0.5rem;
    border-left: 2px solid ${({ theme }) => theme.color.backgroundBrand};
    position: relative;
    line-height: 1.5rem;
    ${(props) => props.hasCloseBtn &&
        `
      background-color: ${props.theme.color.background};
      font-size: 14px !important;
      padding: 0.5rem 1rem;
      border-left: 5px solid ${props.theme.color.backgroundBrand};
      line-height: 1.2rem;
      margin-bottom: 0.2em;
      `}
  `,
    ReplySender: styled.p `
    color: ${({ theme }) => theme.color.text};
    font-weight: 600;
    margin: 0 !important;
  `,
    ReplyText: styled.p `
    margin: 0 !important;
    ${(props) => props.hasCloseBtn &&
        `
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}
  `,
    CloseWrapper: styled.div `
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    cursor: pointer;
  `,
    Span: styled.span `
    font-size: 0.8rem;
    font-style: italic;
    color: ${({ theme }) => theme.color.textMuted}!important;
  `,
};
export default ReplyMessage;
//# sourceMappingURL=ReplyMessage.styled.js.map